var render = function render(_c,_vm){return _c('div',{staticClass:"header-badge",class:[_vm.data.class, _vm.data.staticClass]},[_c('p',{staticClass:"header"},[_vm._v(_vm._s(_vm.props.header))]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }